import React, { useEffect, useRef, useState } from 'react';
import '../../../Static/priceinfo.css';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, useMediaQuery, Button } from '@mui/material';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { selectQuotData, selectQuotView } from '../../Selectors/Master/ItemSelectors';
import { fetchQuotatuionData, fetchQuotViewlist } from '../../../Store/PHPSlice/Sale/Quotation';
import ReactToPrint from 'react-to-print';
import { Grid, Paper } from '@mui/material';
import Dropdown from '../../FieldsComponents/Dropdown';

const QuotationInfo = () => {
    const [formData, setFormData] = useState({
        itemNm: '',
        firmNm: '',
        priceNm: '',
        partyNm: '',
        schlNm: '',
        jobrate: '',
        outSrc: '',
        extra: '',
        mcloth: '',
        mrate: '',
        mpanna: '',
        m1cloth: '',
        m1rate: '',
        m1panna: '',
        m2cloth: '',
        m2rate: '',
        m2panna: '',
        m3cloth: '',
        m3rate: '',
        m3panna: '',
        profit: '',
        loss: ''
    });
    const { Id } = useParams();
    const dispatch = useDispatch();
    const viewlist = useSelector(selectQuotView);
    const quotlist = useSelector(selectQuotData);
    const [itemData, setItemData] = useState([]);
    const isDesktop = useMediaQuery('(min-width:768px)');
    const componentRef = useRef(); // Ref for the component to be printed
    useEffect(() => {
        // dispatch(fetchQuotViewlist(Id));
        dispatch(fetchQuotatuionData(Id));
    }, [Id, dispatch]);

    useEffect(() => {
        // if (quotlist.data) {
        //     const item = quotlist.data;
        //     setFormData(prev => ({
        //         ...prev,
        //         itemNm: item.itemNm || '',
        //         firmNm: item.firmNm || '',
        //         priceNm: item.grpNm || '',
        //         partyNm: item.partyNm || '',
        //         schlNm: item.schoolNm || '',
        //         jobrate: item.jobrate || '',
        //         outSrc: item.outSrc || '',
        //         extra: item.extra || '',
        //         mcloth: item.clothNm || '',
        //         mrate: item.rate || '',
        //         mpanna: item.panna || '',
        //         m1cloth: item.m1cloth || '',
        //         m1rate: item.m1rate || '',
        //         m1panna: item.m1panna || '',
        //         m2cloth: item.m2cloth || '',
        //         m2rate: item.m2rate || '',
        //         m2panna: item.m2panna || '',
        //         m3cloth: item.m3cloth || '',
        //         m3rate: item.m3rate || '',
        //         m3panna: item.m3panna || '',
        //         profit: item.profit || '',
        //         loss: item.loss || '',
        //         party_gst: item.party_gst,
        //         party_adrs: item.party_adrs,
        //         party_pan: item.party_pan,
        //         party_ph: item.party_ph,
        //         party_email: item.party_email,

        //     }));
        // }
    }, [quotlist]);

    const tableContainerStyle = {
        marginLeft: isDesktop ? '5%' : '0%',
        width: isDesktop ? '90%' : '100%',
        overflow: 'hidden',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none'
    };

    const webkitScrollbarStyle = {
        overflowX: 'auto',  // Ensure the x-axis scrollbar is visible
        overflowY: 'hidden', // Hide the y-axis scrollbar
        WebkitOverflowScrolling: 'touch', // Enable smooth scrolling on iOS
    };


    // console.log(quotlist)
    const renderTableRow = (size, index) => {
        const newAvgM = itemData.mavg[index];
        const newAvgM1 = itemData.m1avg[index];
        const newAvgM2 = itemData.m2avg[index];
        const newAvgM3 = itemData.m3avg[index];

        // var m0rate = viewlist.data.length > 0 ? viewlist.data.map(val => parseFloat(val.rate)) : 0;
        // var m1rate = viewlist.data.length > 0 ? viewlist.data.map(val => parseFloat(val.m1rate)) : 0;
        // var m2rate = viewlist.data.length > 0 ? viewlist.data.map(val => parseFloat(val.m2rate)) : 0;
        // var m3rate = viewlist.data.length > 0 ? viewlist.data.map(val => parseFloat(val.m3rate)) : 0;

        // var outSrc = viewlist.data.length > 0 ? viewlist.data.map(val => parseFloat(val.outSrc)) : 0;

        var m0rate = quotlist.data ? Number(formData.mrate) : 0;
        var m1rate = quotlist.data ? Number(formData.m1rate) : 0;
        var m2rate = quotlist.data ? Number(formData.m2rate) : 0;
        var m3rate = quotlist.data ? Number(formData.m3rate) : 0;

        var outSrc = Number(formData.outSrc);

        let mCal = Number(m0rate) * Number(outSrc) / 100 + Number(m0rate);
        let m1Cal = Number(m1rate) * Number(outSrc) / 100 + Number(m1rate);
        let m2Cal = Number(m2rate) * Number(outSrc) / 100 + Number(m2rate);
        let m3Cal = Number(m3rate) * Number(outSrc) / 100 + Number(m3rate);

        // let mCal = m0rate * outSrc / 100 + m0rate;
        // let m1Cal = m1rate * outSrc / 100 + m1rate;
        // let m2Cal = m2rate * outSrc / 100 + m2rate;
        // let m3Cal = m3rate * outSrc / 100 + m3rate;


        // console.log(mCal)

        // let fm0 = mCal * parseFloat(newAvgM) / 100;
        // let fm1 = m1Cal * parseFloat(newAvgM1) / 100;
        // let fm2 = m2Cal * parseFloat(newAvgM2) / 100;
        // let fm3 = m3Cal * parseFloat(newAvgM3) / 100;

        // let fm0 = m0rate * parseFloat(newAvgM);
        // let fm1 = m1rate * parseFloat(newAvgM1);
        // let fm2 = m2rate * parseFloat(newAvgM2);
        // let fm3 = m3rate * parseFloat(newAvgM3);

        let fm0 = mCal * Number(newAvgM);
        let fm1 = m1Cal * Number(newAvgM1);
        let fm2 = m2Cal * Number(newAvgM2);
        let fm3 = m3Cal * Number(newAvgM3);

        let clothrate = Math.round(fm0) + Math.round(fm1) + Math.round(fm2) + Math.round(fm3);
        var jobrate = viewlist.data.length > 0 ? viewlist.data.map(val => Number(val.jobrate)) : Number(formData.jobrate);
        let calJob = Math.round(clothrate) + jobrate;

        let val_loss = formData.loss ? Number(formData.loss) : 0;
        let cal_loss = calJob * val_loss / 100;
        let final_loss = Math.round(cal_loss + calJob);

        var extra = viewlist.data.length > 0 ? viewlist.data.map(val => Number(val.extra)) : 0;
        let cost = Math.round(final_loss) + Number(extra);

        let firmPer = viewlist.data.length > 0 ? viewlist.data.map(val => Number(val.firmPer)) : 0;
        let mrp = viewlist.data.length > 0 ? viewlist.data.map(val => Number(val.mrpPer)) : 0;

        // let profit = cost * Number(firmPer) / 100;
        let profit = cost * Number(formData.profit) / 100;

        const rate = itemData.rate[index];

        let finalRate = rate ? rate : Math.round(profit + cost);

        let finalMrp1 = finalRate * 65 / 100;
        let finalMrp = Math.round(finalMrp1 + finalRate);

        // let calMrp1 = parseFloat(mrp) / 100;
        // let calMrp2 = 1 - calMrp1;
        // let finalMrp = Math.round(finalRate / calMrp2);

        // let mod = finalMrp % 5;
        // if (mod > 2.5) {
        //     let diff = 5 - mod;
        //     var ans = finalMrp + Math.round(diff);
        // } else {
        //     ans = finalMrp - Math.round(mod);
        // }
        return (
            <TableRow key={index}>
                <TableCell align='center' sx={{ p: 0.4, border: '1px solid #000' }}>{size}</TableCell>
                <TableCell align='center' sx={{ p: 0.4, border: '1px solid #000' }}>{newAvgM}</TableCell>
                <TableCell align='center' sx={{ p: 0.4, border: '1px solid #000' }}>{Math.round(fm0)}</TableCell>
                {formData.m1cloth !== '0' && <>
                    <TableCell align='center' sx={{ p: 0.4, border: '1px solid #000' }}>{newAvgM1}</TableCell>
                    <TableCell align='center' sx={{ p: 0.4, border: '1px solid #000' }}>{Math.round(fm1)}</TableCell>
                </>
                }
                {formData.m2cloth !== '0' &&
                    <>
                        <TableCell align='center' sx={{ p: 0.4, border: '1px solid #000' }}>{newAvgM2}</TableCell>
                        <TableCell align='center' sx={{ p: 0.4, border: '1px solid #000' }}>{Math.round(fm2)}</TableCell>
                    </>
                }
                {formData.m3cloth !== '0' &&
                    <>
                        <TableCell align='center' sx={{ p: 0.4, border: '1px solid #000' }}>{newAvgM3}</TableCell>
                        <TableCell align='center' sx={{ p: 0.4, border: '1px solid #000' }}>{Math.round(fm3)}</TableCell>
                    </>
                }
                <TableCell align='center' sx={{ p: 0.4, border: '1px solid #000' }}>{Math.round(clothrate)}</TableCell>
                <TableCell align='center' sx={{ p: 0.4, border: '1px solid #000' }}>{Math.round(calJob)}</TableCell>
                <TableCell align='center' sx={{ p: 0.4, border: '1px solid #000' }}>{Math.round(final_loss)}</TableCell>
                <TableCell align='center' sx={{ p: 0.4, border: '1px solid #000' }}>{Math.round(cost)}</TableCell>
                {/* <TableCell align='center' sx={{ p: 0.4, border: '1px solid #000' }}>{Math.round(profit)}</TableCell> */}
                <TableCell align='center' sx={{ p: 0.4, border: '1px solid #000' }}>{Math.round(finalRate)}</TableCell>
                <TableCell align='center' sx={{ p: 0.4, border: '1px solid #000' }}>{Math.round(finalMrp)}</TableCell>
            </TableRow>
        );
    };

    const renderPricelistCost = (item, index) => {
        let finalMrp1 = Number(item.rate) * 65 / 100;
        let finalMrp = Math.round(finalMrp1 + Number(item.rate));
        console.log(finalMrp);
        return (
            <TableRow key={index}>
                <TableCell align='center' sx={{ p: 0.4, border: '1px solid #000' }}>{item.size}</TableCell>
                <TableCell align='center' sx={{ p: 0.4, border: '1px solid #000' }}>{item.rate}</TableCell>
                <TableCell align='center' sx={{ p: 0.4, border: '1px solid #000' }}>{finalMrp}</TableCell>
            </TableRow>
        );
    };

    const handleDropdownChange = (e, dropdownType) => {
        const { value } = e.target;
        setFormData({
            ...formData,
            [dropdownType]: value
        });

        if (dropdownType === "itemid2") {
            const item = quotlist?.info?.find(item => item.ID === value);
            setFormData(prev => ({
                ...prev,
                itemNm: item?.itemNm || '',
                firmNm: item?.firmNm || '',
                priceNm: item?.grpNm || '',
                partyNm: item?.partyNm || '',
                schlNm: item?.schoolNm || '',
                jobrate: item?.jobrate || '',
                outSrc: item?.outSrc || '',
                extra: item?.extra || '',
                mcloth: item?.clothNm || '',
                mrate: item?.rate || '',
                mpanna: item?.panna || '',
                m1cloth: item?.m1cloth || '',
                m1rate: item?.m1rate || '',
                m1panna: item?.m1panna || '',
                m2cloth: item?.m2cloth || '',
                m2rate: item?.m2rate || '',
                m2panna: item?.m2panna || '',
                m3cloth: item?.m3cloth || '',
                m3rate: item?.m3rate || '',
                m3panna: item?.m3panna || '',
                profit: item?.profit || '',
                loss: item?.loss || '',
                party_gst: item?.party_gst,
                party_adrs: item?.party_adrs,
                party_pan: item?.party_pan,
                party_ph: item?.party_ph,
                party_email: item?.party_email,
                pricelist_cloth: item?.pricelist_cloth,
                pricelist_type: item?.pricelist_type
            }));

            if (item.pricelist_cloth !== "" && item.pricelist_cloth !== '0') {
                setItemData(item?.info_data);
            } else {
                const data = item?.info_data?.length > 0 ? {
                    size: item?.info_data.map(val => val.size),
                    mavg: item?.info_data.map(val => parseFloat(val.mavg)),
                    m1avg: item?.info_data.map(val => parseFloat(val.m1avg)),
                    m2avg: item?.info_data.map(val => parseFloat(val.m2avg)),
                    m3avg: item?.info_data.map(val => parseFloat(val.m3avg)),
                    rate: item?.info_data.map(val => parseFloat(val.rate)),
                    mrp: item?.info_data.map(val => parseFloat(val.mrp))
                } : [];
                setItemData(data);
            }

        } else {
            setFormData(prev => ({
                ...prev,
                itemNm: '',
                firmNm: '',
                priceNm: '',
                partyNm: '',
                schlNm: '',
                jobrate: '',
                outSrc: '',
                extra: '',
                mcloth: '',
                mrate: '',
                mpanna: '',
                m1cloth: '',
                m1rate: '',
                m1panna: '',
                m2cloth: '',
                m2rate: '',
                m2panna: '',
                m3cloth: '',
                m3rate: '',
                m3panna: '',
                profit: '',
                loss: '',
                party_gst: '',
                party_adrs: '',
                party_pan: '',
                party_ph: '',
                party_email: '',

            }));
            setItemData([]);
        }
    };
    const dropdownlistDepartment = [
        {
            label: 'Item',
            id: 'itemid2',
            options: quotlist?.info || [],
            value: formData.itemid2,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'itemid2', value: newValue ? newValue.ID : '' } }, 'itemid2'),
            getOptionLabel: (option) => option.itemNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
        }
    ];

    return (
        <>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Paper style={{ padding: '3vh', margin: '0' }}>
                        <div style={{ margin: '1%', width: '100%' }} ref={componentRef}>

                            <h3 className='centered-heading'>Quotation View</h3>
                            <div className="dashed-line"></div>

                            {
                                dropdownlistDepartment && dropdownlistDepartment?.map((drop) => (
                                    <Dropdown
                                        key={drop.label}
                                        label={drop.label}
                                        id={drop.id}
                                        options={drop.options}
                                        value={drop.value}
                                        onChange={drop.onChange}
                                        isDesktop={isDesktop}
                                        getOptionLabel={drop.getOptionLabel}
                                        isOptionEqualToValue={drop.isOptionEqualToValue}
                                        valueFinder={drop.valueFinder}
                                    />
                                ))
                            }

                            <table style={{ margin: '1% 5%', fontSize: '14px' }}>

                                <tbody>

                                    <tr>
                                        <td style={{ width: '200px' }}>Item Name</td>
                                        <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='light-color'>{formData.itemNm}</td>
                                        <td style={{ width: '200px', paddingLeft: '2%' }}>Job Rate</td>
                                        <td style={{ padding: ' 0.2% 1.5%' }} className='dark-color'>{formData.jobrate}</td>
                                    </tr>

                                    <tr>
                                        <td style={{ width: '200px' }}>Firm Name</td>
                                        <td style={{ width: '25vw', padding: ' 0.2% 1.5%' }} className='light-color'>{formData.firmNm}</td>
                                        <td style={{ width: '200px', paddingLeft: '2%' }}>Extra</td>
                                        <td style={{ width: '30vw', padding: ' 0.2% 1.5%' }} className='dark-color'>{formData.extra}</td>
                                    </tr>

                                    <tr>
                                        {/* <td style={{ width: '200px' }}>Price List</td>
                                    <td>:</td>
                                    <td style={{ width: '25vw', padding: ' 0 1.5%' }}>{formData.priceNm}</td> */}
                                        <td style={{ width: '200px', paddingLeft: '2%' }}>
                                            Cloth Out Source <br />
                                            <span style={{ color: 'red' }}>(Main + Matching %)</span>
                                        </td>
                                        <td style={{ width: '30vw', padding: ' 0.2% 1.5%' }} className='dark-color'>{formData.outSrc}</td>
                                    </tr>

                                    <tr>
                                        <td style={{ width: '200px' }}>Main Cloth</td>
                                        <td style={{ width: '25vw', padding: '0.2% 1.5%' }} className='light-color'>{formData.mcloth} <b>Panna:{formData.mpanna}</b> <b className='red-color'>Rate:{formData.mrate}</b></td>
                                        {formData.m1cloth !== '0' && (
                                            <>
                                                <td style={{ width: '200px', paddingLeft: '2%' }}>Matching Cloth-1</td>
                                                <td style={{ padding: '0.2% 1.5%' }} className='light-color'>{formData.m1cloth} <b>Panna: {formData.m1panna}</b> <b className='red-color'> Rate: {formData.m1rate}</b></td>
                                            </>
                                        )}
                                    </tr>
                                    <tr>

                                        {formData.m2cloth !== '0' && (
                                            <>
                                                <td style={{ width: '200px', paddingLeft: '2%' }}>Matching Cloth-2</td>
                                                <td style={{ padding: '0.2% 1.5%' }} className='light-color'>{formData.m2cloth} <b>Panna: {formData.m2panna}</b> <b className='red-color'> Rate: {formData.m2rate}</b></td>
                                            </>
                                        )}

                                        {formData.m3cloth !== '0' && (
                                            <>
                                                <td style={{ width: '200px', paddingLeft: '2%' }}>Matching Cloth-3</td>
                                                <td style={{ padding: '0.2% 1.5%' }} className='light-color'>{formData.m3cloth} <b>Panna: {formData.m3panna}</b> <b className='red-color'> Rate: {formData.m3rate}</b></td>
                                            </>
                                        )}
                                    </tr>

                                    <tr>
                                        <td style={{ width: '200px' }}>Party</td>
                                        <td style={{ width: '25vw', padding: '0.2% 1.5%' }} className='dark-color'>{formData.partyNm}</td>
                                        <td style={{ width: '200px' }}>School</td>
                                        <td style={{ width: '25vw', padding: '  0.2% 1.5%' }} className='dark-color'>{formData.schlNm}</td>

                                    </tr>

                                    <tr>
                                        <td style={{ width: '200px' }}>Profit</td>
                                        <td style={{ width: '25vw', padding: '0.2% 1.5%' }} className='dark-color'>{formData.profit}</td>
                                        <td style={{ width: '200px' }}>Value of Loss +</td>
                                        <td style={{ width: '25vw', padding: '  0.2% 1.5%' }} className='dark-color'>{formData.loss}</td>

                                    </tr>

                                    <tr>
                                        <td style={{ width: '200px' }}>Price List Cloth</td>
                                        <td style={{ width: '25vw', padding: '  0.2% 1.5%' }} className='dark-color'>{formData.pricelist_cloth}</td>
                                        <td style={{ width: '200px' }}>Price List Type</td>
                                        <td style={{ width: '25vw', padding: '0.2% 1.5%' }} className='dark-color'>{formData.pricelist_type}</td>

                                    </tr>
                                </tbody>

                            </table>


                            {
                                (formData?.pricelist_cloth !== "" && formData?.pricelist_cloth !== '0') ?
                                    <TableContainer style={{ ...tableContainerStyle, ...webkitScrollbarStyle }}>
                                        <Table>
                                            <TableHead>
                                                <TableRow className='tbl-row'>
                                                    <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Size</TableCell>

                                                    <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Final Rate</TableCell>
                                                    <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>MRP <br /> <span style={{ color: 'red', fontSize: '12px' }}>65%</span></TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {itemData ? itemData?.map((item, index) => renderPricelistCost(item, index)) : ''}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                    :
                                    <TableContainer style={{ ...tableContainerStyle, ...webkitScrollbarStyle }}>
                                        <Table>
                                            <TableHead>
                                                <TableRow className='tbl-row'>
                                                    <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Size</TableCell>
                                                    <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Main Avg.Mtr</TableCell>
                                                    <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>{`Main Avg.Mtr Rate`} <br />+ <span style={{ color: 'red', fontSize: '12px' }}>{`Outsrc(${formData.outSrc}%)`}</span></TableCell>
                                                    {formData.m1cloth !== '0' &&
                                                        <>
                                                            <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>M1 Avg.Mtr</TableCell>
                                                            <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>M1 Avg.Mtr Rate <br /> + <span style={{ color: 'red', fontSize: '12px' }}>{`Outsrc(${formData.outSrc}%)`}</span></TableCell>
                                                        </>
                                                    }
                                                    {formData.m2cloth !== '0' &&
                                                        <>
                                                            <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>M2 Avg.Mtr</TableCell>
                                                            <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>M2 Avg.Mtr Rate <br />+ <span style={{ color: 'red', fontSize: '12px' }}>{`Outsrc(${formData.outSrc}%)`}</span></TableCell>
                                                        </>
                                                    }
                                                    {formData.m3cloth !== '0' &&
                                                        <>
                                                            <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>M3 Avg.Mtr</TableCell>
                                                            <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>M3 Avg.Mtr Rate <br />+ <span style={{ color: 'red', fontSize: '12px' }}>{`Outsrc(${formData.outSrc}%)`}</span></TableCell>
                                                        </>
                                                    }
                                                    <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Total Cloth Rate <br /> <span style={{ color: 'red', fontSize: '12px' }}>(Main + Matching)</span></TableCell>
                                                    <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Job Rate <br /> <span style={{ color: 'red', fontSize: '12px' }}>(+{formData.jobrate})</span></TableCell>
                                                    <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Value of Loss <br /> <span style={{ color: 'red', fontSize: '12px' }}>{`(${formData.loss}%)`}</span> </TableCell>
                                                    <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Extra <br /> <span style={{ color: 'red', fontSize: '12px' }}>(+{formData.extra})</span></TableCell>

                                                    <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Profit / Final Rate <br /> <span style={{ color: 'red', fontSize: '12px' }}>{`(${formData.profit}%)`}</span></TableCell>
                                                    <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>MRP <br /> <span style={{ color: 'red', fontSize: '12px' }}>65%</span></TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {itemData.size ? itemData.size.map((item, index) => renderTableRow(item, index)) : ''}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>

                            }


                        </div>
                        <div style={{ margin: '2% 5%', paddingBottom: '2%' }}>
                            <ReactToPrint
                                trigger={() => <Button variant="contained" color="primary">Print</Button>}
                                content={() => componentRef.current}
                            />
                        </div>
                    </Paper>
                </Grid>

            </Grid>
        </>
    );
};

export default QuotationInfo;
